import PageHeader from "../../components/PageHeader";
import { InspecaoProvider } from "./context/InspecaoContext";
import { InspecaoResumoSection } from "./components/InspecaoResumoSection";
import { InspecaoPedidosSection } from "./components/InspecaoPedidosSection";

const Inspecao: React.FC = () => {
  return (
    <InspecaoProvider>
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <PageHeader
          title="Inspeção"
          description="Tempos médios por etapa no período selecionado (data inicial e final)."
        />

        <InspecaoResumoSection />
        <InspecaoPedidosSection />
      </div>
    </InspecaoProvider>
  );
};

export default Inspecao;
